import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./CustomerDetails.css";

const CustomerDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { customer } = location.state || {};

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleViewTicketClick = () => {
    navigate("/admin/dashboard/ticket-details", {
      state: {
        customerId: customer.customer_id,
        customerName: `${customer.first_name} ${customer.last_name}`,
        customerEmail: customer.email,
        customerPhone: customer.phone_no,
      },
    });
  };

  return (
    <div className="customer-details">
      <h2>Customer Details</h2>
      <table className="details-table">
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Service Details</th>
            <th>Raised Ticket</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {customer
                ? `${customer.first_name} ${customer.last_name}`
                : "N/A"}
            </td>
            <td>{customer ? customer.product_sku : "N/A"}</td>
            <td>
              <button
                className="view-ticket-button"
                onClick={handleViewTicketClick}
              >
                Raised Ticket
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <button className="back-button" onClick={handleBackClick}>
        Back
      </button>
    </div>
  );
};

export default CustomerDetails;
